import { render } from "./LocaleChanger.vue?vue&type=template&id=d0769c42&scoped=true"
import script from "./LocaleChanger.vue?vue&type=script&lang=js"
export * from "./LocaleChanger.vue?vue&type=script&lang=js"

import "./LocaleChanger.vue?vue&type=style&index=0&id=d0769c42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0769c42"]])

export default __exports__